import React from "react";

/**
 * Dokunmatik ekranlardaki bilgi kartının kabı.
 *
 * Soluk sarı zemin (`bg-mainYellow`) kalktı: üstündeki metin miras aldığı
 * renkle geldiği için koyu temada okunmuyordu ve dört sarı düğmenin yanında
 * ekran tek renge boğuluyordu. Artık tema yüzeyi + marka rengi ince şerit.
 *
 * Yükseklik düğme sırasıyla aynı (150px) ki üst blok tek satırda hizalansın.
 */
const BoxShadow = ({ children, extraClass = "" }) => {
  return (
    <div
      className={`relative mt-[10px] h-[150px] w-full overflow-hidden rounded-xl border border-line bg-surface p-3 pl-4 text-content shadow-card ${extraClass}`}
    >
      {/* Marka rengi — sol kenarda dikey şerit */}
      <span className="absolute inset-y-0 left-0 w-1.5 bg-brand-400" />
      {children}
    </div>
  );
};

export default BoxShadow;
